import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CustomPathPage } from './custom-path';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared';
import { CustomPathDragComponent } from './components/custom-path-drag.component';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    CustomPathPage,
    CustomPathDragComponent
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: CustomPathPage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class CustomPathPageModule {}
